export default __webpack_public_path__ + "static/media/plate.d19e5b23.svg";